import { render } from "./CatalogPage.vue?vue&type=template&id=43076878&scoped=true"
import script from "./CatalogPage.vue?vue&type=script&lang=js"
export * from "./CatalogPage.vue?vue&type=script&lang=js"

import "./CatalogPage.vue?vue&type=style&index=0&id=43076878&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43076878"]])

export default __exports__